// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createHook,
	type BoundActions,
} from '@atlassian/react-sweet-state';
import * as actions from './actions.tsx';
import type { State, ContainerProps } from './types.tsx';

const initialState: State = {
	data: null,
	loading: false,
	error: null,
};

type Actions = typeof actions;
export type UserSubscriberActions = BoundActions<State, Actions>;

const Store = createStore<State, Actions>({
	name: 'user',
	initialState,
	actions,
});

export const UserContainer = createContainer<State, Actions, ContainerProps>(Store);

export const useUserSubscriber = createHook(Store);

export const useUserSubscriberActions = () => {
	const [, userActions] = useUserSubscriber();
	return [undefined, userActions] as const;
};
